import { getMetricGroup } from '@gonfalon/openapi/operations/getMetricGroup';
import { getMetricGroups } from '@gonfalon/openapi/operations/getMetricGroups';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getMetricGroupsQuery = createQueryOptions(getMetricGroups);

export const getMetricGroupQuery = createQueryOptions(getMetricGroup);
